export default __webpack_public_path__ + "static/media/use_action_hk.12cfbb20.png";